class GetStationOptionsUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute(EMR){
    const result= await this.repository.getSensorOptions(EMR)
    return result
  }
}
export {
  GetStationOptionsUseCase,
};
